import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { exportToExcel } from '../../utils/exportExcel';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: '10px',
        textAlign: 'center'
    },
    container: {
        maxHeight: 440,
    },
    modal: {
        position: 'absolute',
        width: 400,
        backgroundColor: '#fff',
        border: '2px solid #000',
        boxShadow: 5,
        padding: '16px 32px 24px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    iconos: {
        cursor: 'pointer'
    },
    inputMaterial: {
        width: '100%'
    }
}));

const ComprasExcel = ({ url }) => {
    const classes = useStyles();

    const excelData = {
        sheets: [
            {
                data: url,
                columns: [
                    { label: 'Numero', value: 'numero' },
                    { label: 'Responsable', value: 'responsable' },
                    { label: 'Solicitante', value: 'agente' },
                    { label: 'Sector', value: 'sector' },
                    { label: 'Estado', value: 'estado' },
                    { label: 'Fecha de Novedad', value: 'fecha_de_novedad' },
                    { label: 'Fecha de Compra', value: 'fecha_de_compra' },
                    { label: 'Fecha de Entrega', value: 'fecha_de_entrega' },
                ],
                name: 'Empleados',
            },
        ],
        fileName: 'MisDatos',
    };

    const handleDownload = () => {
        excelData.sheets.forEach(sheet => {
            exportToExcel(sheet.data, excelData.fileName, sheet.name, sheet.columns);
        });
    };

    return (
        <Paper className={classes.root}>
            <Button variant="contained" color="success" onClick={handleDownload} className="mi-boton">
                Descargar Excel
            </Button>
        </Paper>
    );
}

export default ComprasExcel;
